import behaviourConstants from "@/constants/behaviourManagementConstants.js"

const pages = {
  settingsPage() {
    return {
      name: "Behavior Management Settings",
      path: behaviourConstants.PATHS.SETTINGS_CORE_VALUE,
      roles: behaviourConstants.BEHAVIOUR_ADMIN_ROLES,
      dependency: behaviourConstants.ROUTE_DEPENDENCY.SETTINGS
    }
  }
}

export default {
  pages
}
